<script>
/**
 * 賞翻天後台
    增加監控的頁面
    會顯示目前有人在抽的商品及是誰在抽

 * 欄位有
 * 商品編號/商品名稱/類別/售價/剩餘抽數/總抽數/會員email/會員暱稱/保護時間剩餘（秒）

 * 頁面名稱 就叫即時抽況
 * 權限管理者

 * 要有手動刷新的按鈕以及自動刷新（每1分鐘

搜尋商品名稱/會員名稱/email
 */
import common from "@/mixins/common";
import { mapActions } from "vuex";
import ProductDetail from "@/pages/product/ProductDetail.vue";

export default {
  name: "instantDraw",
  components: {ProductDetail},
  mixins: [common],
  data() {
    return {
      searchProduct: "",
      searchUser: "",
      searchEmail: "",

      searchType: null, // 用於存儲當前選擇的搜索類型
      searchValue: "", // 用於存儲搜索值
      searchTypes: [
        { value: "name", text: "商品名稱" },
        { value: "nickname", text: "會員名稱" },
        { value: "email", text: "會員 Email" },
      ],
      headers: [
        { text:'編輯', value:'edit', isEvent: true, color: '#0ba7a3', sortable: false },
        {
          text: "商品編號 (點擊開啟商品頁)",
          value: "productId",
          align: "start",
        },
        { text: "商品名稱", value: "name", align: "start" },
        { text: "類別", value: "category", align: "start" },
        { text: "售價", value: "price", align: "start" },
        { text: "剩餘抽數", value: "balance", align: "start" },
        { text: "總抽數", value: "count", align: "start" },
        { text: "會員email", value: "email", align: "start" },
        { text: "會員暱稱", value: "nickname", align: "start" },
        {
          text: "保護時間剩餘（秒）",
          value: "protectSec",
          align: "start",
        },
      ],
      isAutoRefreshing: false, // 用於控制自動刷新狀態
      instantDrawItems: [],
      editView: {
        event: 'add',
        visible: false,
        item: null,
        showCancel: true,
        confirmEvent: ()=>{},
        cancelEvent: ()=>{},
      },
    };
  },
  methods: {
    ...mapActions(["getInstantDraw", "getProductInfo", "getAdminProductInfo"]),
    /*
     * 查詢即時抽況資料，若有選擇搜尋值則帶入 searchQuery: [{ key : 'name', value: 'iPhone'}]
     * 若無則查詢所有資料
     */
    async loadData() {
      this.isAutoRefreshing = true; // 開始自動刷新時設置為
      let data = {};
      if (this.searchType && this.searchValue) {
        data = {
          searchQuery: [{ key: this.searchType, value: this.searchValue }],
        };
      } else {
        data = {
          searchQuery: [],
        };
      }

      try {
        const res = await this.getInstantDraw(data);
        console.log(`loadData ${JSON.stringify(res)}`);
        if (res.data.statusCode === 0) {
          this.instantDrawItems = res.data.data;
        }
      } catch (e) {
        console.log(`loadData error`, e.stack);
      } finally {
        this.isAutoRefreshing = false; // 無論成功或失敗，結束自動刷新時設置為 false
      }
    },
    search() {
      if (!this.searchType || !this.searchValue) {
        alert("請選擇搜索類型並輸入搜索內容");
        return;
      }

      console.log(`正在搜索 ${this.searchType}: ${this.searchValue}`);
      // 這裡實現實際的搜索邏輯，可能需要調用 API 或過濾本地數據
      this.loadData();
    },
    clearSearch() {
      this.searchType = null;
      this.searchValue = "";
      // 重置搜索結果或重新加載所有數據
      this.loadData(); // 假設您有一個 loadData 方法來加載初始數據
    },
    startAutoRefresh() {
      this.autoRefreshInterval = setInterval(() => {
        this.loadData(); // 每 60 秒自動加載資料
      }, 60000); // 60000 毫秒 = 60 秒
    },
    stopAutoRefresh() {
      clearInterval(this.autoRefreshInterval); // 清除定時器
    },
    getCategories() {
      return [
        { key: 0, value: "一番賞" },
        { key: 1, value: "自製賞" },
        { key: 4, value: "3C賞" },
        { key: 3, value: "紅利賞" },
        { key: 5, value: "刮刮樂" },
        { key: 6, value: "福利區" },
        { key: 7, value: "日用品" },
        { key: 2, value: "盲盒" },
        { key: 8, value: "18+" },
      ];
    },
    getCategoryValue(key) {
      const category = this.getCategories().find((cat) => cat.key === key);
      return category ? category.value : "未知類別"; // 如果找不到對應的類別，顯示 '未知類別'
    },
    async cellEvent(item){
      console.log(`cellEvent ${JSON.stringify(item)}`);
      if (!item.prizeList) {
        item.prizeList = [];
      }

      const res = await this.getAdminProductInfo({ productId: item.productId });
      const result = res.data;

      console.log(`getProductInfo == ${JSON.stringify(result)}`);

      this.editView.title = '修改商品';
      this.editView.event = 'edit';
      this.editView.item = result.data;
      this.editView.visible = true;
      this.editView.cancelEvent = ()=>{
        this.editView.visible = false;
      }
      this.editView.confirmEvent = ()=>{
        this.editView.visible = false;
        this.loadData();
      }
    }
  },
  created() {
    this.loadData(); // 初始加載資料
    this.startAutoRefresh(); // 開始自動刷新
  },
  beforeDestroy() {
    this.stopAutoRefresh(); // 組件銷毀前停止自動刷新
  },
};
</script>

<template>
  <v-container fluid>
    <!-- 搜尋欄：商品名稱 input /會員名稱 input /email input / 搜尋按鈕
          * 一次只能搜一種 -->
    <v-layout class="align-center">
      <v-select
        v-model="searchType"
        :items="searchTypes"
        label="選擇搜索類型"
        class="mr-3"
      ></v-select>
      <v-text-field
        v-model="searchValue"
        :label="
          searchType
            ? searchTypes.find((t) => t.value === searchType).text
            : '請先選擇搜索類型'
        "
        :disabled="!searchType"
        class="mr-3"
      ></v-text-field>
      <v-btn
        color="blue lighten-2"
        @click="search"
        :disabled="!searchType || !searchValue"
        >搜尋</v-btn
      >
      <v-btn color="red lighten-2" @click="clearSearch" class="ml-3"
        >清空查詢</v-btn
      >
    </v-layout>

    <!-- 手動刷新按鈕 -->
    <v-layout class="justify-start align-center" style="gap: 10px">
      <v-btn color="blue lighten-2" @click="loadData()"
        >手動刷新
        <!-- 來個 icon -->
        <v-icon>mdi-refresh</v-icon>
      </v-btn>
      <!-- 自動刷新提示文字 -->
      <span class="text-caption">每 1 分鐘自動刷新</span>
      <!-- 藍色的字和轉圈圈的動畫 -->
      <div class="d-flex align-center text-blue text-caption">
        <span v-if="isAutoRefreshing">正在刷新資料</span>
        <v-icon v-if="isAutoRefreshing" class="rotating-icon text-blue"
          >mdi-refresh</v-icon
        >
      </div>
    </v-layout>

    <!-- 欄位有
          商品編號/商品名稱/類別/售價/剩餘抽數/總抽數/會員email/會員暱稱/保護時間剩餘（秒） -->
    <v-data-table
      :headers="headers"
      :items="instantDrawItems"
      :items-per-page="1000"
      hide-default-footer
    >
      <template v-slot:item="{ item }">
        <tr>
          <!-- * 點擊商品連結到開新視窗，顯示商品頁 -->
          <td>
            <v-btn :color="'#0ba7a3'" dark
                   @click.stop="cellEvent(item)">編輯</v-btn>
          </td>
          <td>
            <a
              :href="`https://kujiflip.tw/product/?productId=${item.productId}`"
              target="_blank"
              >{{ item.productId }}</a
            >
          </td>
          <td>{{ item.name }}</td>
          <td>{{ getCategoryValue(item.category) }}</td>
          <td>{{ item.price }}</td>
          <td>{{ item.balance }}</td>
          <td>{{ item.count }}</td>
          <td>{{ item.email }}</td>
          <td>{{ item.nickname }}</td>
          <td>{{ item.protectSec }}</td>
        </tr>
      </template>
    </v-data-table>

    <product-detail :event="editView.event"
                    :title="editView.title" :visible="editView.visible"
                    :item-detail="editView.item"
                    :show-cancel="editView.showCancel"
                    @cancelEvent="editView.cancelEvent"
                    @confirmEvent="editView.confirmEvent"/>
  </v-container>
</template>

<style scoped>
.rotating-icon {
  animation: spin 1s linear infinite; /* 旋轉動畫 */
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.text-blue {
  color: rgb(81, 139, 197); /* 確保文字顏色為藍色 */
}
</style>
